<template>
  <CModal title="Xem trước danh sách" :show.sync="isShow" size="lg" :closeOnBackdrop="false">
    <CRow class="content-fade-in">
      <CCol md="12">
        <CForm class="form-basic">
          <CRow>
            <CCol sm="12" md="12" xl="12">
              <div v-if="type == 0" style="text-align: center; background-color: white;">
                <div :class="animateIn" ref="textNormalContent">{{items[index].content}}</div>
              </div>
              <div v-if="type == 1">
                <img style="width: 100%; height: 40vh" :class="animateIn" ref="img" :src="items[index].url" :alt="items[index].url" />
              </div>
            </CCol>
          </CRow>
        </CForm>
      </CCol>
    </CRow>
    <template v-slot:footer>
      <div slot="footer">
        <button type="button" class="btn btn-secondary" @click="isShow = false" :disabled="loadingPopupPlayList.value">
          <i class="fa fa-close"></i> Hủy bỏ
        </button>
      </div>
    </template>
    <BaseLoading :loading="loadingPopupPlayList.value"></BaseLoading>
  </CModal>
</template>

<script>
import BaseLoading from "../base/BaseFormLoading";
export default {
  name: "PreviewPlayList",
  components: { BaseLoading },
  props: ["items", "animateIn", "animateOut", "type"],
  data() {
    return {
      loadingPopupPlayList: { value: false },
      index: 0,
      isShow: true
    }
  },
  methods: {
    nextContent() {
      let that = this
      var duration = that.items[that.index].duration.split(':')
      var seconds = (+duration[0]) * 60 * 60 + (+duration[1]) * 60 + (+duration[2]) * 1000
      seconds = 10000;
      setTimeout(() => {
        if(that.$refs['textNormalContent'].classList) {
          that.$refs['textNormalContent'].classList.value = that.animateIn
        }
        if (that.index < that.items.length - 1) {
          that.index += 1
        } else {
          that.index = 0
        }
      }, seconds)
      setTimeout(() => {
        if(that.$refs['textNormalContent'].classList) {
          that.$refs['textNormalContent'].classList.value = that.animateOut
        }
      }, seconds - 1000)
    },
    nextImage() {
      let that = this
      var duration = that.items[that.index].duration.split(':') // split it at the colons
      var seconds = (+duration[0]) * 60 * 60 + (+duration[1]) * 60 + (+duration[2]) * 1000
      seconds = 10000
      setTimeout(() => {
        if(that.$refs['img'].classList) {
          that.$refs['img'].classList.value = that.animateIn
        }
        if (that.index < that.items.length - 1) {
          that.index += 1
        } else {
          that.index = 0
        }
      }, seconds)

      setTimeout(() => {
        if(that.$refs['img'].classList) {
          that.$refs['img'].classList.value = that.animateOut
        }
      }, seconds - 1000)
    },
  },
  mounted() {
    if (this.type == 0) {
      this.nextContent()
    }

    if (this.type == 1) {
      this.nextImage()
    }
  },
  watch: {
    'isShow': function (value) {
      this.$emit("updateIsShowPopupPlayList", value);
    },
    index() {
      if (this.type == 0) {
        this.nextContent()
      }

      if (this.type == 1) {
        this.nextImage()
      }

    }
  }
}
</script>
